import { useTranslation } from "react-i18next";

export default function Disclaimer() {
  const { t } = useTranslation("blog-kozijn-schilderen");

  return (
    <div className="border-t border-brand-border pt-6 md:pt-8">
      <p className="font-geist text-xs md:text-sm text-brand-text/40 italic leading-relaxed">
        {t("disclaimer")} Laatst bijgewerkt mei 2026.
      </p>
    </div>
  );
}